import Model from '@newspaces/zero-base/Model';
import BaseOrganisationUser from '@newspaces/zero-base/models/OrganisationUser';
import CustomPermissions from './CustomPermissions.js';
import '@newspaces/zero-base/Runtime';
import './AccessCredential.js';
import 'nanoid';
import '@newspaces/zero-base/DateTime';
import '@blueid/access-proto';
import './Organisation.js';
import 'nanoid/generate';
import '@newspaces/zero-base/models/Organisation';
import '@newspaces/zero-base/utils';
import '../AccessSite-5abc043f.js';
import '../AccessCountries-3e45c6a9.js';
import '../AccessGroup-4a811995.js';
import './AccessTimeSchedule.js';
import '../i18n.js';
import '@newspaces/zero-base/i18n';
import '../canRemoveDocuments-3b897618.js';
import '../parseChangeSet-03074a6b.js';
import './AccessObject.js';
import '../AccessDevice-68531278.js';
import './AccessConfiguration.js';
import './AccessVendor.js';

const queryDocument = async (filter, options, context) => {
  const permissionsResult = BaseOrganisationUser.queryDocument(filter, options, context);
  if (!permissionsResult) {
    return permissionsResult;
  }
  permissionsResult.fields.push("customPermissions");
  return permissionsResult;
};

const Permissions = Model.mergePermissions(BaseOrganisationUser.Permissions, {
  read: {
    query: queryDocument
  }
});

class OrganisationUser extends BaseOrganisationUser {
  static Permissions = Permissions;
  static Fields = {
    // Permissions
    customPermissions: {
      type: CustomPermissions
    }
  };
  constructor(data) {
    super(OrganisationUser.Fields, data);
  }
}
Model.declareModel(OrganisationUser);

export { OrganisationUser as default };
//# sourceMappingURL=OrganisationUser.js.map
